import React, { useEffect, useState } from "react";
import { getBrandDetails } from "../lib/getBrandDetails";
import useFetch from "../hooks/useFetch";
import { Link } from "react-router-dom";
import AddToChat3 from "../components/AddToChat3";
import AddToList from "../components/AddToList";
import useModalStore from "../StatesStore/ModalStore";
import useActiveBrandsStore from "../StatesStore/ActiveBrands";
const ProductCardBottom = ({
  isSmallScreen,
  product,
  componentName,
  listName,
}) => {
  const [brandData, setBrandData] = useState(null);
  const { activeBrands } = useActiveBrandsStore();
  const fetchBrandData = async () => {
    try {
      // Fetch the brand's display name and logo using the getDisplayName function
      const result = await getBrandDetails(product?.supplier, activeBrands);
      setBrandData(result);
      // console.log("result", result);
    } catch (error) {
      console.error("Error getting brand data:", error);
    }
  };

  useEffect(() => {
    if (!product) {
      console.log("product is missing");
      return;
    }
    if (!activeBrands) {
      console.log("activeBrands is missing");
      return;
    }
    fetchBrandData();
  }, [product, activeBrands]);
  return (
    <div
      className={`d-flex justify-content-between flex-column`}
      style={{
        gap: isSmallScreen ? "8px" : "8px",
        padding: isSmallScreen ? "6px 3px 3px 3px" : "6px 3px 3px 3px",
        borderRadius: "0px 0px 6px 6px",
        borderWidth: "0px 1px 1px 1px",
        borderStyle: "solid",
        borderColor: "#0000001A",
      }}
    >
      <div
        className="d-flex flex-column"
        style={{
          gap: isSmallScreen ? "2px" : "2px",
          width: "86%",
        }}
      >
        <Link
          to={`/BrandHome/${brandData?.name}`}
          style={{
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: isSmallScreen ? "12px" : "13px",
            lineHeight: "100%",
            letterSpacing: "0%",
            color: "#676A79",
          }}
        >
          {brandData?.displayName}
        </Link>
        <Link
          to={`/ProductDetails/${product?.id}`}
          className="text-truncate"
          title={product?.name}
          style={{
            fontFamily: "Inter",
            fontWeight: "600",
            fontSize: isSmallScreen ? "13px" : "13px",
            letterSpacing: "0%",
            color: "#000000",
          }}
        >
          {product?.name || `${brandData?.displayName}'s Product`}
        </Link>
      </div>
      <div
        className="d-flex w-100"
        style={{ gap: isSmallScreen ? "2px" : "2px" }}
      >
        <AddToChat3 product={product} componentName={"productCard"} />
        <AddToList product={product} componentName={"productCard"} />
      </div>
    </div>
  );
};

export default ProductCardBottom;
